<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} SMS Campaign</div>
      <router-link class="btn-blue" :to="{name:'SMS Campaigns'}">SMS Campaign {{ $tc("list") }}</router-link>
    </div>
    <div>
      Campaign Name:&nbsp;{{campaign_name}}
      <br />
      Campaign Type:&nbsp;{{selectedCampaignType.campaign_type_name}}
      <br />
      Audience:&nbsp;{{selected_segment.segment_name}}
      <br />
      Campaign Start Date:&nbsp;{{campaign_start_date}}
      <br />
      Campaign End Date:&nbsp;{{campaign_end_date}}
      <br />
      Content Type:&nbsp;{{selected_radio}}
      <br />
      SMS Template:&nbsp;{{selected_sms_template.sms_temp_name}}
      <br />
      SMS Provider:&nbsp;{{selected_sms_provider.sp_name}}
      <br />
      SMS Sender:&nbsp;{{selected_sms_sender.ss_name}}
      <br />
      Delivery Date and Time:&nbsp;{{delivery_datetime}}
      <br />
      Delivery Time:&nbsp;{{selected_radio_delivery}}
      <br />
    </div>
  </div>
</template>
<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import moment from "moment";
export default {
  data() {
    return {
      selected_sms_template: null,
      campaign_details: "",

      selected_sms_provider: {
        sp_id: 0,
        sp_name: ""
      },

      selected_sms_sender: {
        ss_id: 0,
        ss_name: ""
      },

      selected_segment: {
        s_id: 0,
        segment_name: ""
      },
      campaign_name: "",
      campaign_start_date: "",
      campaign_end_date: "",
      sms_message: "",

      selected_radio: "",
      delivery_datetime: "",

      selected_radio_delivery: "",

      selectedCampaignType: {
        campaign_type_name: "",
        ct_id: 0
      }
    };
  },
  beforeMount() {
    const { sc_id } = this.$route.params;
    console.log("sc_id :", sc_id);
    if (sc_id) {
      this.getCampaignDetails({ sc_id: sc_id });
    } else {
      this.$router.go(-1);
    }
  },

  methods: {
    getCampaignDetails(payload) {
      MarketingAutomation.getSmsCampaignDetails({ sc_id: payload.sc_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.campaign_details = data.Records[0];
            console.log("this.campaign_details :", this.campaign_details);
            this.campaign_name = this.campaign_details.campaign_name;
            this.selectedCampaignType.campaign_type_name = this.campaign_details.campaign_type_name;
            this.selectedCampaignType.ct_id = this.campaign_details.ct_id;
            this.selected_segment.segment_name = this.campaign_details.segment_name;
            this.selected_segment.s_id = this.campaign_details.s_id;
            this.campaign_start_date = moment(
              this.campaign_details.campaign_start_date
            ).format("MMMM Do YYYY");
            this.campaign_end_date = moment(
              this.campaign_details.campaign_end_date
            ).format("MMMM Do YYYY");
            this.selected_sms_template = {
              sms_id: this.campaign_details.sms_id,
              sms_temp_name: this.campaign_details.sms_temp_name
            };
            if (this.campaign_details.sp_id !== null) {
              this.selected_sms_provider.sp_id = this.campaign_details.sp_id;
              this.selected_sms_provider.sp_name = this.campaign_details.sp_name;
            } else {
              this.selected_sms_provider = null;
              console.log(
                " this.selected_sms_provider:",
                this.selected_sms_provider
              );
            }
            if (this.campaign_details.ss_id !== null) {
              this.selected_sms_sender.ss_id = this.campaign_details.ss_id;
              this.selected_sms_sender.ss_name = this.campaign_details.ss_name;
            } else {
              this.selected_sms_sender = null;
            }

            if (this.campaign_details.date_time) {
              this.delivery_datetime = moment
                .unix(this.campaign_details.date_time)
                .format("MMMM Do YYYY,  h:mm:ss a ");
            }

            if (this.campaign_details.is_promotional == "Y") {
              this.selected_radio = "Promotional";
            } else {
              this.selected_radio = "Transactional";
            }
            if (this.campaign_details.is_send_now !== null) {
              if (this.campaign_details.is_send_now == "Y") {
                this.selected_radio_delivery = "Now";
              } else {
                this.selected_radio_delivery = "Later";
              }
            }
          } else {
            this.selected_segment = null;
            this.selected_sms_sender = null;
            this.selected_sms_provider = null;

            // this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/SmsComponents/viewSmsCampaign.vue